const GROUP_TYPES = {
  header: "header",
  container: "container",
  card: "card"
};
export {
  GROUP_TYPES
};
